import { SET_PROVIDERS } from '@actions/threePLProviders'

const intialProviderList = []

export const threePLProviders = (state = intialProviderList, action) => {
  const { type, providers } = action
  switch (type) {
    case SET_PROVIDERS:
      return providers
    default:
      return state
  }
}
